// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] || chunkId) + "-legacy." + {"56":"e3e4b4ab","70":"54b8339b","102":"b5b45170","133":"265a4c1b","182":"00a35680","641":"29d8bc96","652":"16eb1a6e","653":"8f460a9a","683":"c2d67e74","895":"c2d8e61b"}[chunkId] + ".js";
};